import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PriceBookIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PriceBook",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M25.141 2.285H9.142a3.433 3.433 0 0 0-3.428 3.43v3.428H4.572a1.143 1.143 0 1 0 0 2.285h1.142v3.428H4.572a1.143 1.143 0 1 0 0 2.286h1.142v3.429H4.572a1.142 1.142 0 1 0 0 2.285h1.142v3.429c0 1.89 1.538 3.43 3.428 3.43h16c1.89 0 3.429-1.54 3.429-3.43V5.715c0-1.891-1.54-3.43-3.43-3.43m1.144 24c0 .63-.513 1.144-1.144 1.144H9.142c-.63 0-1.143-.514-1.143-1.144v-3.429h1.143a1.142 1.142 0 1 0 0-2.285H8v-3.429h1.143a1.143 1.143 0 1 0 0-2.286H8v-3.428h1.143a1.143 1.143 0 1 0 0-2.285H8V5.715c0-.631.513-1.144 1.143-1.144h16c.63 0 1.143.513 1.143 1.144z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.421 14.856h-2.285a1.144 1.144 0 0 1 0-2.286h4.571a1.143 1.143 0 1 0 0-2.286h-2.29V9.143a1.143 1.143 0 1 0-2.286 0v1.142a3.433 3.433 0 0 0-3.424 3.428 3.43 3.43 0 0 0 3.429 3.429h2.285c.63 0 1.144.512 1.144 1.143s-.513 1.143-1.144 1.143h-4.57a1.142 1.142 0 1 0 0 2.285h2.28v1.143a1.142 1.142 0 1 0 2.286 0v-1.143h.004c1.89 0 3.43-1.538 3.43-3.428s-1.54-3.429-3.43-3.429"
    })]
  }));
};
PriceBookIcon.displayName = 'PriceBookIcon';